import * as React from "react";
import { forwardRef, memo } from "react";
const SvgAdd = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("mask", { id: "mask0_603_91953", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24 })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_603_91953)" }, /* @__PURE__ */ React.createElement("path", { d: "M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z" })));
const ForwardRef = forwardRef(SvgAdd);
const Memo = memo(ForwardRef);
export { Memo as ReactComponent };
